import { PageHero } from "@/components/public/Layout";
import { Reveal, SectionLabel, ArchImage } from "@/components/public/shared";
import { useEnquiry } from "@/components/public/EnquiryProvider";
import { IMG } from "@/lib/images";
import { Check } from "lucide-react";

export default function Catering() {
  const { open } = useEnquiry();
  const occasions = ["Weddings", "Engagements", "Receptions", "Anniversaries", "Birthdays", "Kitty Parties", "Private Parties", "Social Gatherings", "Religious & Social Functions", "Premium Celebrations"];
  return (
    <div>
      <PageHero label="Event & Celebration Catering" title="Every celebration deserves its own experience." subtitle="Bespoke pure-vegetarian & Jain-Friendly catering for the moments that matter most — designed, cooked and served with care." image={IMG.banquet} />

      <section className="bg-ivory py-20 sm:py-28">
        <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
          <Reveal className="lg:col-span-6">
            <SectionLabel>Occasions We Cater</SectionLabel>
            <h2 className="mt-5 font-display text-3xl font-light text-espresso sm:text-4xl">From intimate gatherings to grand celebrations</h2>
            <p className="mt-5 text-inkmuted">We design menus, live counters and service around your guests, your theme and your dietary needs — always 100% pure vegetarian & Jain-Friendly.</p>
            <div className="mt-8 grid grid-cols-2 gap-x-6 gap-y-3">
              {occasions.map((o) => (
                <div key={o} className="flex items-center gap-2 text-sm text-espresso/90">
                  <Check className="h-4 w-4 shrink-0 text-gold" /> {o}
                </div>
              ))}
            </div>
            <button data-testid="catering-plan-event" onClick={() => open("event")} className="mt-10 inline-flex items-center gap-2 bg-espresso px-8 py-4 text-[12px] font-semibold uppercase tracking-editorial text-ivory transition-colors hover:bg-gold">
              Plan Your Event
            </button>
          </Reveal>
          <Reveal className="lg:col-span-6" delay={120}>
            <div className="grid grid-cols-2 gap-4">
              <ArchImage src={IMG.indianWeddingBuffet} alt="Indian wedding catering buffet" ratio="aspect-[3/4]" />
              <ArchImage src={IMG.fineTable} alt="Fine dining table" ratio="aspect-[3/4]" className="mt-10" />
            </div>
          </Reveal>
        </div>
      </section>

      <section className="bg-cream py-20 sm:py-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Reveal className="mb-12 text-center"><SectionLabel className="justify-center">How We Work</SectionLabel>
            <h2 className="mt-5 font-display text-4xl font-light text-espresso sm:text-5xl">A seamless journey</h2></Reveal>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-4">
            {[["Enquiry", "Share your occasion, guest count and preferences."], ["Consultation", "Our hospitality team designs a tailored proposal."], ["Menu & Tasting", "Curate cuisines, counters and Jain-friendly menus."], ["Flawless Service", "Trained teams execute your event, end to end."]].map(([t, d], i) => (
              <Reveal key={t} delay={i * 60}>
                <div className="border-t-2 border-gold bg-ivory p-7">
                  <span className="font-display text-4xl text-gold/40">0{i + 1}</span>
                  <h3 className="mt-2 font-display text-xl text-espresso">{t}</h3>
                  <p className="mt-2 text-sm text-inkmuted">{d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
